import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export const fetchSite = async () => (await api.get("/site")).data;
export const fetchGallery = async () => (await api.get("/gallery")).data;
export const submitQuote = async (payload) => (await api.post("/quotes", payload)).data;

// Auth
export const exchangeSession = async (session_id) =>
    (await api.post("/auth/session", { session_id })).data;
export const authMe = async () => (await api.get("/auth/me")).data;
export const authLogout = async () => (await api.post("/auth/logout")).data;

// Admin
export const adminUpdateSite = async (patch) =>
    (await api.put("/admin/site", patch)).data;
export const adminListQuotes = async () => (await api.get("/admin/quotes")).data;
export const adminUpdateQuote = async (id, patch) =>
    (await api.patch(`/admin/quotes/${id}`, patch)).data;
export const adminDeleteQuote = async (id) =>
    (await api.delete(`/admin/quotes/${id}`)).data;
export const adminAddGallery = async (payload) =>
    (await api.post("/admin/gallery", payload)).data;
export const adminDeleteGallery = async (id) =>
    (await api.delete(`/admin/gallery/${id}`)).data;
